<template>
    <div
        class="lateral-content-backgroud"
        :class="{
            'hide-lateral-content-backgroud': !value,
        }"
    >
        <div class="lateral-content-close" @click="close()" :title="$t('fechar')">
            <b-icon icon="close" type="is-white" size="is-medium" />
        </div>
        <div
            ref="lateralContent"
            class="lateral-content-container"
            :class="{
                'lateral-content-large': !compact,
                'lateral-content-compact': compact,
            }"
        >
            <div class="lateral-content-header" v-if="header">
                <h1 class="title">{{ title }}</h1>
                <div class="lateral-content-header-right" v-if="!headerHideClose">
                    <slot name="header-right" :id="id">
                        <b-button
                            type="is-warning is-silver"
                            icon-right="close"
                            @click="close()"
                            :disabled="isLoading"
                            v-tippy 
                            :title="$t('fechar')"
                        />
                    </slot>
                </div>
            </div>
            <div class="lateral-content">
                <slot :id="id">{{ $t('conteudo') }}</slot>
            </div>
            <div class="lateral-content-footer" v-if="footer">
                <div>
                    <slot name="footer-left" :id="id">
                        <b-button
                            type="is-warning is-silver"
                            icon-right="close"
                            @click="close()"
                            :disabled="isLoading"
                            v-tippy 
                            :title="$t('fechar')"
                        />
                    </slot>
                </div>
                <div class="lateral-content-footer-right">
                    <slot name="footer-right" :id="id"></slot>
                    <!-- 
                        Como usar
                        <template v-slot:footer-right="{id}"></template>
                    -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LateralContent',

    props: {
        // ativo/inativo
        value: {
            type: Boolean,
            default: false,
        },
        // dados sendo carregados/processados
        isLoading: {
            type: Boolean,
            default: false,
        },
        // largura reduzida
        compact: {
            type: Boolean,
            default: false,
        },
        // mostrar barra de título
        header: {
            type: Boolean,
            default: false,
        },
        // mostrar botão fechar junto com o título
        headerHideClose: {
            type: Boolean,
            default: false,
        },
        // mostrar barra inferior com botão fechar
        footer: {
            type: Boolean,
            default: false,
        },
        // caso queira pegar um id para retornar por slot
        id: {
            type: Number,
            default: 0,
        },
        // título caso o header esteja ativado
        title: {
            type: String,
            default: '',
        },
        // Pedir se tem certeza que deseja fechar
        confirmClose: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        // console.log(this.$refs['lateralContent']);
        // this.$refs[0].lateralContent.addEventListener('keydown', (evt) => {
        //     if (evt.key === 'Escape') {
        //         alert('Escape pressed');
        //     }
        // });
    },
    methods: {
        close() {
            if (this.confirmClose) {
                this.$root.confirm({
                    message: this.$t('msg-confirmacao-fechar'),
                    onConfirm: (_) => this.$emit('input', false),
                });
            } else {
                this.$emit('input', false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
// background com opção de fechar
.lateral-content-backgroud {
    z-index: 1000;
    position: fixed;
    background-color: rgba(73, 73, 73, 0.5);
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    // align-items: center;
    align-items: stretch;
    justify-content: right;
    transition: opacity 0.4s linear;
    transform: translate(0);

    .lateral-content-close {
        position: absolute;
        left: 5px;
        top: 5px;
        cursor: pointer;
    }
    // 240px é o tamanho do menu
    // conteúdo largo
    .lateral-content-large {
        width: calc(90% - 240px);
    }
    // conteúdo compacto
    .lateral-content-compact {
        width: 550px;
    }
    @media screen and (max-width: 800px) {
        .lateral-content-compact {
            width: 95% !important;
        }
    }
    // largura em que o menu colapsa
    @media screen and (max-width: 1200px) {
        .lateral-content-large {
            width: 95% !important;
        }
    }

    .lateral-content-container {
        position: relative;
        z-index: 1000;
        border-top-left-radius: 8px;
        // border-bottom-left-radius: 5px;
        background-color: $bg-color;
        border-top: solid 1px #d9d9d9;
        border-left: solid 1px #d9d9d9;
        border-bottom: solid 1px #d9d9d9;
        -webkit-box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);
        box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);
        display: flex;
        flex-direction: column;
        cursor: auto;
        // height: auto;
        // max-height: 90%;
        transition: 0.4s;
        margin-top: 35px;

        .lateral-content {
            overflow-y: scroll;
            flex-grow: 1;
        }

        .lateral-content-header {
            border-top-left-radius: 8px;
            background-color: #fff;
            padding: 10px;
            -webkit-box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
            box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title {
                padding-bottom: 0;
            }
            .lateral-content-header-right {
                display: flex;
                .is-silver {
                    color: $semi-title-color;
                    box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
                    @include exclude-button();
                }
            }
        }
        .lateral-content-footer {
            // border-bottom-left-radius: 5px;
            background-color: #fff;
            padding: 10px;
            -webkit-box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
            box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
            display: flex;
            justify-content: space-between;

            .is-silver {
                color: $semi-title-color;
                box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
                @include exclude-button();
            }
            .lateral-content-footer-right {
                display: flex;
            }
        }
    }
}
.hide-lateral-content-backgroud {
    transform: translate(9999px);
    opacity: 0;
}
</style>
